import * as v from 'valibot'

export const STARTING_PAGES = [
  'company-courses',
  'exclusive-content',
  'learning-paths-active',
  'learning-paths-all',
  'learning-paths-mandatory',
  'homepage',
  'discovery-page',
] as const

export const StartingPageSchema = v.picklist(STARTING_PAGES)

export type StartingPage = v.InferOutput<typeof StartingPageSchema>

export const DEFAULT_STARTING_PAGE: StartingPage = 'homepage'

export function isStartingPage(value: unknown): value is StartingPage {
  return v.is(StartingPageSchema, value)
}
